<template>
  <div>
    <!--买入期限大于产品期限-->
    <div class="model-container animated-5 fadeIn transRiskTip" v-if="isShowMore">
      <div class="model-box posi-relative">
        <p class="model-title flex-jf-btw">
          <span class="mdl-title">温馨提示</span>
          <span></span>
        </p>
        <!-- 主要内容 -->
        <div class="model-content">
          <div class="txt-left">买入产品的最短持有期（持有期类产品）/封闭期（定期开放类产品）大于您在风险测评中的曾提交的计划投资期限，是否继续？</div>
          <div class="txt-center">
            <btn-middle @click="close" classCpt="btn-free">否</btn-middle>
            <btn-middle @click="goOnHandleTime" classCpt="">是</btn-middle>
          </div>
        </div>
      </div>
    </div>
    <!-- 年龄大于70 -->
    <div class="model-container animated-5 fadeIn transRiskTip" v-if="isShowAge">
      <div class="model-box posi-relative">
        <p class="model-title flex-jf-btw">
          <span class="mdl-title">温馨提示</span>
          <span></span>
        </p>
        <!-- 主要内容 -->
        <div class="model-content">
          <div class="txt-left">*{{fundBuyPrompt}}</div>
          <div class="txt-center">
            <btn-middle @click="goOnHandleAge" classCpt="">确定</btn-middle>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      isShowAge:false,
      isShowMore:false,
      userAge:'',
      userBuyTime:'',
      productTime:'',
      isNext:false,
      fundBuyPrompt:'',
    }
  },
  props:{
    item: {
      type: Object,
      default: () => ({})
    },
  },
  mounted(){
    this.isNext = false
    this.userAge = this.$store.state.userInfo.age
    // this.userAge = 80
    this.userBuyTime = sessionStorage.getItem('custFundTimeLimit')
    
    if(Object.keys(this.item).length !==0){
      this.productTime = this.item.productTime
      this.fundBuyPrompt = this.item.fundBuyPrompt || 'kong'
    }else{
      this.productTime = 0
      this.fundBuyPrompt = 'kong'
      console.log('没有传值！！！！')
    }
    // this.productTime = 100000
    console.log(Number(this.productTime),'productTime')
    console.log(Number(this.userBuyTime),'userBuyTime个人期望投资期限')
    console.log(this.userAge,'投资者年龄')
    
    if(Number(this.userBuyTime) < Number(this.productTime)){
      this.isShowMore = true
      return false
    }
    if(this.userAge>70 && this.productTime>=365&&this.fundBuyPrompt!='kong'){
      this.isShowAge = true
      return false
    }
    this.isNext = true
    console.log(this.isNext,'没有弹窗，下一步！！！！！！！')
  },
  methods:{
    close(){
      this.$emit('close')
    },
    goOnHandleTime(){
      this.isShowMore = false
      if(this.userAge>70 && this.productTime>=365&&this.fundBuyPrompt!='kong'){
        this.isShowAge = true
      }else{
        this.$emit('nextGo')
      }
    },
    goOnHandleAge(){
      this.isShowAge = false
      this.$emit('nextGo')
    },
  }  
}
</script>
<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/moreTimeBox.vue